import { put } from "@redux-saga/core/effects";

import { FieldsService } from "./../../../services/fields";
import { AddOptionRequestActionType, optionsResponse } from "./../types";
import { addOptionFailure, addOptionSuccess } from "./../actionCreaters";

export function* addOptionSaga({ payload: { fieldId, option, otherId } }: AddOptionRequestActionType) {
    try {
        const {
            data: { data },
        }: optionsResponse = yield FieldsService.addOption(fieldId, option);

        yield put(addOptionSuccess({ fieldId, options: data.options }));
    } catch (error) {
        yield put(addOptionFailure({ fieldId }));
    }
}
